const EMAIL_PATTERN =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-ZÀ-ž\-0-9]+\.)+[a-zA-ZÀ-ž]{2,}))$/;
// eslint-disable-next-line no-control-regex
const NON_ASCII_EXCEPT_DIACRITICAL_PATTERN = /[^\x00-\x7FÀ-ž]/;

const isEmail = (email) => {
  const emailString = String(email).toLowerCase();

  return !NON_ASCII_EXCEPT_DIACRITICAL_PATTERN.test(emailString) && EMAIL_PATTERN.test(emailString);
};

export default isEmail;
